var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-list"},[(_vm.errosPai)?_c('Message',{attrs:{"closable":false,"severity":"error"}},[_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.errosPai))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }